<template>
    <div id="c2cIndex">
        <Header title="C2C交易" class="headerBox">
            <span slot="right" @click="$router.push({path:'/myC2c'})">
                <img src="../../assets/img/c2c/c2cList.png" class="rightImg"/>
            </span>
        </Header>
        <!-- 导航tab -->
        <van-tabs
                v-model="activeTab"
                :border="false"
                background="#f9f9f9"
                color="#1FC26D"
                line-height="3px"
                line-width="30px"
                title-active-color="#333"
                @change="tabChange">
            <van-tab title="购买" name="buy">
                <c2cIndexList type="buy" v-if="activeTab==='buy'"></c2cIndexList>
            </van-tab>
            <van-tab title="出售" name="sell">
                <c2cIndexList type="sell" v-if="activeTab==='sell'"></c2cIndexList>
            </van-tab>
            <van-tab title="发布订单" name="publish">
                <publishC2c :publishData="publishData"></publishC2c>
            </van-tab>
        </van-tabs>
        <Tabbar active="c2c"></Tabbar>
    </div>
</template>

<script>
    import Tabbar from "../../components/tabbar";
    import Header from "../../components/header";
    import c2cIndexList from "./components/c2cIndexList";
    import publishC2c from "./components/publishC2c.vue";

    export default {
        name: "c2c-index",
        components: {
            Header,
            Tabbar,
            c2cIndexList,
            publishC2c,
        },
        data() {
            return {
                activeTab: "buy",
                publishData: {}
            }
        },
        methods: {
            // 导航切换事件
            tabChange() {
                if (this.activeTab === "publish") {
                    this.ajax.post('appapi/c2c/releaseC2c', {coin: "usdt"}).then((res) => {
                        if (res.data.code === 1) {
                            console.log(res.data);
                            this.publishData = res.data.data;
                        }
                    });
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    #c2cIndex {
        background: #f9f9f9;

        .headerBox {
            background: #f9f9f9 !important;
        }

        .rightImg {
            width: 32px;
            height: 28px;
        }
    }
</style>
